import React, {useEffect, useState} from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Grid,
  Button,
  createMuiTheme,
  ThemeProvider,
  Divider,
} from '@material-ui/core';
import '../OwnerInfo.sass';
import States from 'ApplicationEntry/models/States';
import {maskPhoneNumber, unmaskPhoneNumber} from 'Shared/utilities/phoneNumberMasker';
import {KeyboardDatePicker} from '@material-ui/pickers';

import {ContingentBeneficiary, relations} from 'ApplicationEntry/models/ContingentBeneficiary';
import {ApplicantType} from 'ApplicationEntry/models/ApplicantType';

import {maskTaxId, unMaskTaxId} from 'Shared/utilities/taxIdMasker';
import {SocialSecurityNumber, isValidSocialSecurityNumber} from 'ApplicationEntry/models/SocialSecurityNumber';
import {ZipCode, isValidZipCode, unmaskZipCode, ValidZipCode, maskZipCode} from 'ApplicationEntry/models/ZipCode';
import {ValidPhoneNumber, PhoneNumber, isValidPhoneNumber} from 'ApplicationEntry/models/PhoneNumber';
import {red} from '@material-ui/core/colors';
import * as ErrorMessages from '../ErrorMessages';
import * as MA from 'ApplicationEntry/models/ModalApplication';
import contingentBeneficiary from 'ApplicationEntry/ducks/contingentBeneficiary';
import { getManagedStatus } from 'ApplicationEntry/api/awdApi';
import * as CD from 'ApplicationEntry/ducks/caseDetails';
import { useDispatch } from 'react-redux';
import { Alert } from '@material-ui/lab';

const theme = createMuiTheme({
  palette: {
    secondary: red,
  },
});

type ContingentBeneficiaryProps = {
  index: number;
  key: number;
  contingentBeneficiaryIndex: number;
  editContingentBeneficiary: boolean;
  removeContingentBeneficiary: () => void;
  changeFirstName: (value: string) => void;
  changeMiddleName: (value: string) => void;
  changeLastName: (value: string) => void;
  changeRelationship: (value: string) => void;
  changeDOB: (value: Date | '') => void;
  changeSSN: (value: string) => void;
  changePercent: (value: number) => void;
  changeAddress: (value: string) => void;
  changeAddressLine2: (value: string) => void;
  changeCity: (value: string) => void;
  changeState: (value: string) => void;
  changeZip: (value: ZipCode) => void;
  changePhone: (value: PhoneNumber) => void;
  changeSignatureDate: (value: Date | '') => void;
  members: ContingentBeneficiary;
  contingentBeneficiaryListLength: number;
  totalPercent: number;
  modalApplication: MA.InvalidModalApplication | MA.ValidModalApplication;
};

const isInvalidDate = (date: Date) => isNaN(date.getTime());
const getSSNErrorMessage = (ssn: SocialSecurityNumber) =>
  !isValidSocialSecurityNumber(ssn) ? ErrorMessages.INVALID_SSN_FORMAT : null;
const getPhoneErrorMessage = (phone: PhoneNumber) =>
  !isValidPhoneNumber(phone) ? ErrorMessages.INVALID_PHONE_FORMAT : null;
const getZipErrorMessage = (zip: ZipCode) => (!isValidZipCode(zip) ? ErrorMessages.INVALID_ZIP_FORMAT : null);
const getPercentErrorMessage = (percent: number) =>
  percent === 0 ? ErrorMessages.REQUIRED_MESSAGE : ErrorMessages.INVALID_PERCENTAGE;

const ContingentBeneficiaryData = (props: ContingentBeneficiaryProps) => {
  const {
    members,
    changeAddress,
    changeAddressLine2,
    changeCity,
    changeDOB,
    changeFirstName,
    changeLastName,
    changeMiddleName,
    changePercent,
    changeRelationship,
    changeSSN,
    changeState,
    changeZip,
    changePhone,
    changeSignatureDate,
    totalPercent,
    modalApplication,
  } = props;

  
  const {application} = modalApplication;
  // groupCaseDetails.caseDetails.signatureDate.value;
  const [fieldDisabled] = React.useState(true);
  const [percentBlurred, setBlurPercent] = useState(false);
  const [dobBlurred, setBlurDob] = useState(false);
  const [signatureDateblur, setSignatureDateBlur] = useState(false);
  const [SSNBlurred, setBlurSSN] = useState(false);
  const [phoneBlurred, setBlurPhone] = useState(false);
  const [ZipBlurred, setBlurZip] = useState(false);

  const [stateLabel, setStateLabel] = useState<HTMLLabelElement | null>();
  const [relationshipLabel, setRelationshipLabel] = useState<HTMLLabelElement | null>();

  const showPercentError = percentBlurred && totalPercent > 100;
  const showDobError = dobBlurred && members.dob !== '' && isInvalidDate(members.dob);
  const showSignatureDateError = signatureDateblur && members.signatureDate !== '' && isInvalidDate(members.signatureDate);
  const showSSNError = SSNBlurred && !isValidSocialSecurityNumber(members.socialSecurityNumber);
  const showPhoneError = phoneBlurred && members.phone.phoneNumber !== '' && !isValidPhoneNumber(members.phone);
  const showZipError = ZipBlurred && members.zip.value !== '' && !isValidZipCode(members.zip);
  // application.caseDetails.managedStatus

  const handleContingentBeneficiary = () => {
    props.removeContingentBeneficiary();
  };

  let yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const dispatch = useDispatch();
  const fetchUserData = async () => {
    if (application.policyRecord.status.value === 'BEEAPPRV') {
      let ssn1 = application.policyRecord.caseNumber.value;
      const user = await getManagedStatus(ssn1);

      let pacDataResultData1;
      if (user['right']) {
        pacDataResultData1 = user['right']['beneficiaryCaseDetail'];
        const { managedStatus } = pacDataResultData1;
        let emp;
        if (managedStatus === null) {
          emp = "AHL Managed";
        } else {
          emp = managedStatus.valueOf().toString();
        }
        if (emp === "Employer Managed") {
          dispatch(CD.updateManagedStatusFlag(true));
        } else {
          dispatch(CD.updateManagedStatusFlag(false));
        }
        dispatch(CD.updateManagedStatus(managedStatus));
      } else if(user['left']){
        dispatch(CD.updateManagedStatusFlag(false));
      }
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <>
      <div className="contingent-beneficiary-section__contingent-beneficiary-view">
        <div className="contingent-beneficiary-section__contingent-beneficiary-view__sub-title-container">
          <Typography
            variant="subtitle1"
            className="contingent-beneficiary-section__contingent-beneficiary-view__sub-title-container-title"
          >
            Contingent Beneficiary{' '}
            {props.editContingentBeneficiary
              ? props.contingentBeneficiaryIndex + 1
              : props.contingentBeneficiaryListLength + props.index + 1}
          </Typography>
          {props.index !== 0 ? (
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleContingentBeneficiary}
                className="contingent-beneficiary-section__contingent-beneficiary-view__sub-title-container-delete-btn"
              >
                REMOVE CONTINGENT BENEFICIARY
              </Button>
            </ThemeProvider>
          ) : null}
        </div>
        <form
          noValidate
          autoComplete="off"
          className="contingent-beneficiary-section__contingent-beneficiary-view__owner-info-section"
        >
          {application.caseDetails.managedStatusFlag.valueOf().toString() === 'true' ? (
            <Alert severity="info" className="case-details-section__reserved-alert">
              Beneficiary is Employer Managed.
            </Alert>
          ) : null}
          <div className="contingent-beneficiary-section__contingent-beneficiary-view__owner-info-section__row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
                <TextField
                  id="first-name"
                  label="First Name"
                  variant="outlined"
                  placeholder="Enter First Name"
                  margin="normal"
                  className="owner-info-section__text-field"
                  fullWidth
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  onChange={e => changeFirstName(e.target.value)}
                  value={members.firstName.value}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="middle-name"
                  label="Middle Name"
                  variant="outlined"
                  placeholder="Enter Middle Name"
                  margin="normal"
                  fullWidth
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  className="owner-info-section__text-field"
                  value={members.middleName.value}
                  onChange={e => changeMiddleName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="last-name"
                  label="Last Name"
                  variant="outlined"
                  placeholder="Enter Last Name"
                  margin="normal"
                  fullWidth
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  className="owner-info-section__text-field"
                  value={members.lastName.value}
                  onChange={e => changeLastName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="percent"
                  label="Percent"
                  variant="outlined"
                  placeholder="Enter Percent"
                  margin="normal"
                  fullWidth
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  className="owner-info-section__text-field"
                  type="number"
                  error={showPercentError}
                  helperText={showPercentError ? getPercentErrorMessage(members.percent) : ''}
                  onBlur={() => setBlurPercent(true)}
                  value={members.percent}
                  onChange={e => changePercent(parseInt(e.target.value))}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="contingent-ssn"
                  label="SSN"
                  variant="outlined"
                  placeholder="XXX-XX-XXXX"
                  inputProps={{
                    maxLength: 11,
                  }}
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  className="owner-info-section__text-field"
                  error={showSSNError}
                  helperText={showSSNError ? getSSNErrorMessage(members.socialSecurityNumber) : ''}
                  onBlur={() => setBlurSSN(true)}
                  value={maskTaxId(members.socialSecurityNumber.value)}
                  onChange={e => changeSSN(unMaskTaxId(e.target.value))}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" className="owner-info-section__text-field">
                  <InputLabel ref={setRelationshipLabel} id="dependent-label">
                    Relationship
                  </InputLabel>
                  <Select
                    labelId="label-dependent"
                    id="dependent"
                    labelWidth={relationshipLabel?.clientWidth}
                    disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                    value={members.relationship.value}
                    onChange={e => changeRelationship(e.target.value as ApplicantType)}
                    displayEmpty
                  >
                    <MenuItem value="">&nbsp;&nbsp;</MenuItem>
                    {relations.map(rel => (
                      <MenuItem value={rel} key={rel}>
                        {rel}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <KeyboardDatePicker
                  inputVariant="outlined"
                  label="Date of Birth"
                  format="MM/dd/yyyy"
                  variant="inline"
                  className="owner-info-section__text-field"
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  error={showDobError}
                  helperText={showDobError ? ErrorMessages.INVALID_DATE : ''}
                  value={members.dob || null}
                  onBlur={() => setBlurDob(true)}
                  onChange={date => changeDOB(date?.toJSDate() || '')}
                  autoOk={true}
                  maxDate={yesterday}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="contingent-phone-number"
                  label="Phone Number"
                  variant="outlined"
                  placeholder="(XXX) XXX-XXXX"
                  inputProps={{
                    maxLength: 14,
                  }}
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  value={maskPhoneNumber(members.phone.phoneNumber)}
                  error={showPhoneError}
                  helperText={showPhoneError ? getPhoneErrorMessage(members.phone) : ''}
                  onBlur={() => setBlurPhone(true)}
                  onChange={e => changePhone(ValidPhoneNumber.create(unmaskPhoneNumber(e.target.value)))}
                  className="owner-info-section__text-field"
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="address"
                  label="Address"
                  variant="outlined"
                  placeholder="Enter Address"
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  margin="normal"
                  className="owner-info-section__text-field"
                  value={members.address.value}
                  onChange={e => changeAddress(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="addressLine2"
                  label="Address Line 2"
                  variant="outlined"
                  placeholder="Enter Address Line 2"
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  margin="normal"
                  className="owner-info-section__text-field"
                  value={members.addressLine2.value}
                  onChange={e => changeAddressLine2(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="city"
                  label="City"
                  variant="outlined"
                  placeholder="Enter City"
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  margin="normal"
                  className="owner-info-section__text-field"
                  value={members.city.value}
                  onChange={e => changeCity(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" className="owner-info-section__text-field">
                  <InputLabel ref={setStateLabel} id="owner-state">
                    State
                  </InputLabel>
                  <Select
                    labelId="label-owner-state"
                    id="select-owner-state"
                    disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                    labelWidth={stateLabel?.clientWidth}
                    value={members.state.value}
                    onChange={e => changeState(e.target.value as ApplicantType)}
                    displayEmpty
                  >
                    <MenuItem value="">&nbsp;&nbsp;</MenuItem>
                    {States.map(stateCode => (
                      <MenuItem value={stateCode} key={stateCode}>
                        {stateCode}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="owner-zip"
                  label="Zip"
                  variant="outlined"
                  placeholder="XXXXX-XXXX"
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  inputProps={{
                    maxLength: 10,
                  }}
                  className="contingent-beneficiary-section__zip"
                  error={showZipError}
                  helperText={showZipError ? getZipErrorMessage(members.zip) : ''}
                  onBlur={() => setBlurZip(true)}
                  value={maskZipCode(members.zip.value)}
                  onChange={e => changeZip(ValidZipCode.create(unmaskZipCode(e.target.value)))}
                />
              </Grid>
              {/* <Grid item xs={12} md={3}>
                <KeyboardDatePicker
                  inputVariant="outlined"
                  label="Signature Date"
                  format="MM/dd/yyyy"
                  variant="inline"
                  className="owner-info-section__text-field"
                  disabled={(application.caseDetails.managedStatusFlag.valueOf().toString() === 'true')}
                  error={showSignatureDateError}
                  helperText={showSignatureDateError ? ErrorMessages.INVALID_DATE : ''}
                  value={(members.signatureDate.valueOf().toString() === "NaN" ? null : members.signatureDate) || null}
                  onBlur={() => setSignatureDateBlur(true)}
                  onChange={date => changeSignatureDate(date?.toJSDate() || '')}
                  autoOk={true}
                  maxDate={yesterday}
                />
              </Grid> */}
            </Grid>
          </div>
        </form>
      </div>

      <Divider className="application-form__actions-divider" />
    </>
  );
};

export default ContingentBeneficiaryData;
